class ShippingOptionsByLocation {
  constructor(params) {
    this.textHeader = params.textHeader;
    this.textFooter = params.textFooter;
    this.shippings = params.shippings.map(shipping => ({
      price: shipping.price,
      maxPrice: shipping.maxPrice,
      shippingTime: shipping.shippingTime,
      name: shipping.name,
      agencyData: shipping.agencyData.map(agency => ({
        name: agency.name,
        extraCost: agency.extraCost,
      })),
    }));
  }
}

export { ShippingOptionsByLocation };



// WEBPACK FOOTER //
// ./src/models/ShippingOptionsByLocation.js